import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { editLoginData_country } from 'src/app/models/medi-prof-login-edit-data';
import { ApiResult, PromiseResult } from 'src/app/models/PromiseResult';
import { Edit_Data, password_edit_api, patientFetchedData } from 'src/app/models/User';
import { OTP_Validate } from 'src/app/models/util.models';
import { CountriesService } from 'src/app/services/countries.service';
import { DaterenderService } from 'src/app/services/daterender.service';
import { PatientService } from 'src/app/services/patient.service';
import { UserService } from 'src/app/services/user.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { OtpInputComponent } from '../../shared/otp-input/otp-input.component';
import { BreadcrumbService } from '../shared/breadcrumb.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@Component({
  selector: 'app-patient-edit-data',
  templateUrl: './edit-data.component.html',
  styleUrls: ['./edit-data.component.css']
})
export class EditDataComponent implements OnInit {

  @ViewChild(OtpInputComponent) OTP_Input: OtpInputComponent;

  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly patientService: PatientService,
    private readonly utilitiesService: UtilitiesService,
    private readonly userService: UserService,
    private readonly countriesService: CountriesService,
    private readonly daterenderService: DaterenderService,
    private readonly route: ActivatedRoute,
    private readonly providerStateService: ProviderStateService
  ) {
    
  }

  editLoginData_country = new editLoginData_country();
  editData = new Edit_Data();
  provider_id: string = "";
  slug: string = "";
  posting: boolean = false;

  async ngOnInit(): Promise<void> {
    this.slug = this.providerStateService.getProviderSlug();
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink:['/', this.slug, 'patient'] },
      { label: 'Edit Data' }
    ]);
    this.provider_id = this.providerStateService.getProviderId();
    this.editData.userGuid = sessionStorage.getItem('userid');
    this.editData.emailData.data.setCurrentType(true);
    this.editData.mobileData.data.setCurrentType(false);
    this.editData.patientEdit_Data.other_data.unique_id = [
      { label: "Driving License", value: "Driving License" },
      { label: "Passport", value: "Passport" },
      { label: "Other Govt. ID", value: "Other Govt. ID" }
    ];
    await this.getCountries();
    await this.getEmailPhoneNo();
    await this.getMembers();
    this.getParams();
    await this.onMemberChange();

  }

  getParams() {
    this.route.queryParamMap.subscribe((res) => {
      if (res.get('patient_guid'))
        this.editData.patientEdit_Data.members.currentGUID = res.get('patient_guid');
      this.editData.patientEdit_Data.patientFetchedCurrentData = this.editData.patientEdit_Data.members.data.filter((ele) => {
        let data: patientFetchedData = ele.value;
        return data.patient_guid == this.editData.patientEdit_Data.members.currentGUID;
      })[0].value;
    });
  }

  async getStates(country_id: number) {
    await this.countriesService
      .getStates(country_id)
      .toPromise()
      .then((result) => {
        result.map((ele) => {
          ele["state_data"] = {
            id: ele.id.toString(),
            name: ele.state_name.toString(),
          }
        })
        this.editData.patientEdit_Data.other_data.states = this.utilitiesService.getSelectItemList(result, "state_name", "state_data");
      })
      .catch((err: HttpErrorResponse) => {
        console.error(err);
      });
  }

  async onMemberChange() {
    await this.editData.copy_json(this.editData.patientEdit_Data.patientEditForm_Data, this.editData.patientEdit_Data.patientFetchedCurrentData);
    await this.getStates(this.editData.patientEdit_Data.patientEditForm_Data.country_id);
    this.editData.patientEdit_Data.patientEditForm_Data.identification_type = null;
    this.editData.patientEdit_Data.patientEditForm_Data.date_of_birth_date = this.editData.patientEdit_Data.patientEditForm_Data.date_of_birth ? new Date(this.editData.patientEdit_Data.patientEditForm_Data.date_of_birth.replace(/-/g, '/')): null;
    this.editData.patientEdit_Data.patientEditForm_Data.selectedState =
    {
      id: this.editData.patientEdit_Data.patientFetchedCurrentData.state_id?.toString(),
      name: this.editData.patientEdit_Data.patientFetchedCurrentData.state_name
    };
    this.editData.patientEdit_Data.patientEditForm_Data.phone_code = "+" + this.editData.patientEdit_Data.patientFetchedCurrentData.country.phone_code;
    this.editData.patientEdit_Data.patientEditForm_Data.primary_contact_ten_digits = this.editData.getPhoneNumber(this.editData.patientEdit_Data.patientEditForm_Data.phone_code, this.editData.patientEdit_Data.patientEditForm_Data.primary_contact_number);
    this.editData.patientEdit_Data.patientEditForm_Data.secondary_contact_ten_digits = this.editData.getPhoneNumber(this.editData.patientEdit_Data.patientEditForm_Data.phone_code, this.editData.patientEdit_Data.patientEditForm_Data.secondary_contact_number);
  }

  async getMembers(): Promise<void> {
    this.editData.patientEdit_Data.members.api_result = new ApiResult(true);
    await this.patientService
      .getMember(this.editData.userGuid)
      .toPromise()
      .then(async (result) => {
        this.editData.patientEdit_Data.members.api_result.PromiseResult = result;
        if (result.success) {
          result.data.patient.forEach(ele => {
            ele["final_name"] = ele.first_name + " " + (ele.middle_name==null?'':ele.middle_name) + " " + ele.last_name;
          });
          this.editData.patientEdit_Data.members.data = this.utilitiesService.getSelectItemList(result.data.patient, "final_name", "");
          this.editData.patientEdit_Data.patientFetchedCurrentData = this.editData.patientEdit_Data.members.data[0].value;
          this.editData.patientEdit_Data.members.currentGUID = this.editData.patientEdit_Data.patientFetchedCurrentData.patient_guid;
        }
        this.editData.patientEdit_Data.members.api_result.Posting = false;
      }).catch((err: HttpErrorResponse) => {
        console.error(err);
        this.editData.patientEdit_Data.members.api_result.Posting = false;
      });
  }

  async getCountries(): Promise<void> {
    await this.countriesService
      .getCountries(this.provider_id)
      .toPromise()
      .then((countries) => {
        countries.forEach((ele) => {
          ele["final_phone_code"] = '+' + String(ele.phone_code);
          ele["final_label_string"] = ele.acronym + " (" + '+' + String(ele.phone_code) + ")";
          this.editLoginData_country.country_codes.push({
            id: Number(ele.id),
            value: {
              label: ele["final_label_string"],
              value: ele["final_phone_code"],
            }
          });
        });
        this.editData.patientEdit_Data.other_data.country = this.utilitiesService.getSelectItemList(countries, "id", "final_phone_code");
      }).catch((err) => {
        console.error(err);
      });
  }

  async getEmailPhoneNo() {
    this.editData.mobile_email_fetch_api_result = new ApiResult(true);
    await this.userService
      .GetUserData(this.editData.userGuid)
      .toPromise()
      .then((result) => {
        if (result.success) {
            this.posting = true;
            this.editData.emailData.has_verified = result.data.has_verified_email;
            this.editData.emailData.value = this.editData.getValue(result.data.e_email);
            this.editData.emailData.data.userid_value = this.editData.getValue(result.data.e_email);
            this.editData.mobileData.has_verified = result.data.has_verified_phone;
            this.editData.mobileData.data.selected_country_data.phone_code = "+" + result.data.country.phone_code.toString();
            this.editLoginData_country.country_id = result.data.country.id;
            this.editData.mobileData.value = this.editData.addSignAtStart(result.data.primary_contact_number);
            this.editData.mobileData.data.userid_value = this.editData.getPhoneNumber(this.editData.mobileData.data.selected_country_data.phone_code, this.editData.mobileData.value);
            this.editData.mobileData.data.country_codes = [this.editLoginData_country.country_codes.filter((ele) => {
              return ele.id == this.editLoginData_country.country_id;
            })[0].value];
        }
        this.editData.mobile_email_fetch_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.editData.mobile_email_fetch_api_result.ServerError = error.error;
        this.editData.mobile_email_fetch_api_result.PromiseResult.success = false;
        this.editData.mobile_email_fetch_api_result.Posting = false;
      });
  }

  displayEmailPhone(value: string) {
    return Boolean(value) ? value : "N/A";
  }

  isPosting() {
    return this.editData.mobile_email_fetch_api_result.Posting ||
      this.editData[this.getCurrentEditKey()].edit_api_result.Posting ||
      this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.Posting ||
      this.editData.patientEdit_Data.patient_update_api_result.Posting ||
      this.editData.password_edit.api_result.Posting;
  }

  editEmail() {
    this.editData.emailData.data.userid_value = this.editData.getValue(this.editData.emailData.value);
    this.editData[this.getCurrentEditKey()].reset_data();
    this.editData.emailData.isEdit = true;
  }

  editMobile() {
    this.editData.mobileData.data.userid_value = this.editData.getPhoneNumber(this.editData.mobileData.data.selected_country_data.phone_code, this.editData.mobileData.value);
    this.editData[this.getCurrentEditKey()].reset_data();
    this.editData.mobileData.isEdit = true;
  }

  cancelEditEmail() {
    this.editData[this.getCurrentEditKey()].reset_data();
    this.editData.emailData.data.userid_value = this.editData.getValue(this.editData.emailData.value);
  }

  cancelEditMobile() {
    this.editData[this.getCurrentEditKey()].reset_data();
    this.editData.mobileData.data.userid_value = this.editData.getPhoneNumber(this.editData.mobileData.data.selected_country_data.phone_code, this.editData.mobileData.value);
  }

  resetEditPassswordApi() {
    this.editData.password_edit.password_edit_api.resetFields();
    this.editData.password_edit.api_result = new ApiResult(false);
  }

  async submitEditPassword() {
    this.editData.password_edit.api_result = new ApiResult(true);
    await this.userService
      .UpdateUserProfile(this.editData.password_edit.password_edit_api, this.editData.userGuid)
      .toPromise()
      .then(result => {
        this.editData.password_edit.api_result.PromiseResult = result;
        if (result.success) {
          this.editData.password_edit.password_edit_api.password_change=false;
          this.editData.password_edit.api_result.ErrorModel.message = "Password Updated Successfully.";
          this.editData.password_edit.password_edit_api.resetFields();
        }
        this.editData.password_edit.api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.editData.password_edit.api_result.ServerError = error.error;
        this.editData.password_edit.api_result.PromiseResult.success = false;
        this.editData.password_edit.api_result.Posting = false;
      });
  }

  async submitEditEmail() {
    this.editData.emailData.data.email = this.editData.emailData.data.userid_value;
    await this.updateCredentials(this.editData.emailData.data.email)
  }

  async submitEditMobile() {
    this.editData.mobileData.data.contact_number = this.editData.mobileData.data.selected_country_data.phone_code + this.editData.mobileData.data.userid_value;
    await this.updateCredentials(this.editData.mobileData.data.contact_number);
  }

  isEmailEdit() {
    return this.editData.emailData.isEdit;
  }

  getCurrentEditKey() {
    return this.isEmailEdit() ? "emailData" : "mobileData";
  }

  async updateCredentials(value: string) {
    this.editData[this.getCurrentEditKey()].edit_api_result = new ApiResult(true);
    await this.userService
      .updateCredentialsPatient(value)
      .toPromise()
      .then((result) => {
        this.editData[this.getCurrentEditKey()].edit_api_result.PromiseResult = result;
        if (result.success) {
          this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api.user_guid = result.data.userid;
          this.editData[this.getCurrentEditKey()].tabViewData.nextTab(1);
          this.set_otp_data(result);
        }
        else {
          this.editData[this.getCurrentEditKey()].edit_api_result.ErrorModel = result.error;
        }
        this.editData[this.getCurrentEditKey()].edit_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.editData[this.getCurrentEditKey()].edit_api_result.ServerError = error.error;
        this.editData[this.getCurrentEditKey()].edit_api_result.PromiseResult.success = false;
        this.editData[this.getCurrentEditKey()].edit_api_result.Posting = false;
      });
  }

  set_otp_data(result: PromiseResult) {
    this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api.service_id = result.data.service_id;
    this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api.retry_after = new Date(result.data.retry_after);
  }

  async otp_resend() {
    this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api.retry = true;
    await this.update_validate_or_resend_otp();
  }

  async otpVerifySubmit() {
    this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api.retry = false;
    await this.update_validate_or_resend_otp();
  }

  async update_validate_or_resend_otp() {
    let data: OTP_Validate = new OTP_Validate();
    this.editData[this.getCurrentEditKey()].otp_data.otp_api_result = new ApiResult(true);
    data = this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api;
    await this.userService
      .credentials_validate_or_resend_otp_patient(data)
      .toPromise()
      .then(async (result) => {
        this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.PromiseResult = result;
        if (result.success) {
          if (this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api.retry) {
            this.set_otp_data(result);
            this.changeDetector.detectChanges();
            this.OTP_Input.init_countdown();
          }
          else {
            this.verified(result);
          }
        }
        this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.ServerError = error.error;
        this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.PromiseResult.success = false;
        this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.Posting = false;
      })
  }

  async patientAccountSubmission() {
    this.editData.patientEdit_Data.patient_update_api_result = new ApiResult(true);
    this.editData.patientEdit_Data.patientEditForm_Data.state_name = this.editData.patientEdit_Data.patientEditForm_Data.selectedState.name;
    this.editData.patientEdit_Data.patientEditForm_Data.state_id = this.editData.patientEdit_Data.patientEditForm_Data.selectedState.id;
    this.editData.patientEdit_Data.patientEditForm_Data.date_of_birth = this.daterenderService.render_data(this.editData.patientEdit_Data.patientEditForm_Data.date_of_birth_date);
    this.editData.patientEdit_Data.patientEditForm_Data.primary_contact_number = this.editData.patientEdit_Data.patientEditForm_Data.phone_code + this.editData.patientEdit_Data.patientEditForm_Data.primary_contact_ten_digits;
    if (this.editData.patientEdit_Data.patientEditForm_Data.secondary_contact_ten_digits.length > 0 && this.editData.patientEdit_Data.patientEditForm_Data.secondary_contact_ten_digits.length == 10) {
      this.editData.patientEdit_Data.patientEditForm_Data.secondary_contact_number = this.editData.patientEdit_Data.patientEditForm_Data.phone_code + this.editData.patientEdit_Data.patientEditForm_Data.secondary_contact_ten_digits;
    } else {
      this.editData.patientEdit_Data.patientEditForm_Data.secondary_contact_number = "";
    }
    this.editData.patientEdit_Data.form_data.form_data = this.editData.patientEdit_Data.form_data.create_form_data(this.editData.patientEdit_Data.patientEditForm_Data, new FormData(), "");
    if (!this.editData.patientEdit_Data.patientEditForm_Data.identification || !this.editData.patientEdit_Data.patientEditForm_Data.identification_type) {
      this.editData.patientEdit_Data.form_data.form_data.delete("identification_type");
      this.editData.patientEdit_Data.form_data.form_data.delete("identification");
    }
   
    await this.patientService
      .UpdateProfile(this.editData.patientEdit_Data.form_data.form_data)
      .toPromise()
      .then(result => {
        this.editData.patientEdit_Data.patient_update_api_result.PromiseResult = result;
        if (result.success) {
          this.editData.patientEdit_Data.patientEditForm_Data.identification_url = result?.data?.identification_url || this.editData.patientEdit_Data.patientEditForm_Data.identification_url;

          this.editData.patientEdit_Data.patientEditForm_Data.avatar_url = result?.data?.avatar_url || this.editData.patientEdit_Data.patientEditForm_Data.avatar_url;

          this.editData.patientEdit_Data.patient_update_api_result.ErrorModel.message = "Member data updated successfully."
        }
        this.editData.patientEdit_Data.patient_update_api_result.Posting = false;
      }).catch((error: HttpErrorResponse) => {
        this.editData.patientEdit_Data.patient_update_api_result.ServerError = error.error;
        this.editData.patientEdit_Data.patient_update_api_result.PromiseResult.success = false;
        this.editData.patientEdit_Data.patient_update_api_result.Posting = false;
      });

  }

  verified(result: PromiseResult) {
    if (result.success) {
      this.editData[this.getCurrentEditKey()].has_verified = true;
      let value: string = ""
      if (this.isEmailEdit()) {
        value = this.editData.emailData.data.email;
      }
      else {
        value = this.editData.mobileData.data.contact_number;
      }
      this.editData[this.getCurrentEditKey()].value = value;
      this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.ErrorModel.message = "Verified Successfully."
      this.editData[this.getCurrentEditKey()].tabViewData.prevTab(0);
      this.editData[this.getCurrentEditKey()].isEdit = false;
    }
  }

}
